'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchError = exports.watch = undefined;
exports.reset = reset;
exports.setAPI = setAPI;
exports.resetAPI = resetAPI;
exports.schedule = schedule;

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

var _rsvp = require('rsvp');

var _defs = require('./defs');

var _dictionary = require('./dictionary');

var _formatEntry = require('./format-entry');

var _formatEntry2 = _interopRequireDefault(_formatEntry);

var _watcher = require('./watcher');

var _watcher2 = _interopRequireDefault(_watcher);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Needed for IE11


var pubsub = (0, _watcher2["default"])();
var errorPubsub = (0, _watcher2["default"])();
var watch = pubsub.watch;
exports.watch = watch;
var watchError = errorPubsub.watch;
exports.watchError = watchError;
var notify = pubsub.notify;
var notifyError = errorPubsub.notify;
var coursesLoaded = {};
var timeout = void 0;
var next = void 0;
var api = void 0;
var headers = void 0;
resetAPI();
prepareNext();
exports["default"] = {
  watch: watch,
  watchError: watchError,
  schedule: schedule,
  reset: reset,
  setAPI: setAPI,
  resetAPI: resetAPI
};

function prepareNext() {
  next = {
    words: {},
    courses: {}
  };
}

function reset() {
  coursesLoaded = {};
  resetAPI();
}

function setAPI(newApi) {
  var newHeaders = arguments.length <= 1 || arguments[1] === undefined ? headers : arguments[1];
  api = newApi;
  headers = newHeaders;
}

function resetAPI() {
  api = _defs.API;
  headers = {};
}

function schedule(_ref) {
  var _ref$words = _ref.words;
  var words = _ref$words === undefined ? [] : _ref$words;
  var _ref$courses = _ref.courses;
  var courses = _ref$courses === undefined ? [] : _ref$courses;
  clearTimeout(timeout);
  pour(next.words, words);
  pour(next.courses, courses);
  timeout = setTimeout(actuallyDownload, _defs.DOWNLOAD_DELAY);
  return new _rsvp.Promise(function (resolve, reject) {
    var unwatch = watch(function () {
      unwatch();
      unwatchError();
      resolve();
    });
    var unwatchError = watchError(function (error) {
      unwatch();
      unwatchError();
      reject(error);
    });
  });
}

function pour(collection, items) {
  // This rule is necessary for this function to work

  /* eslint no-param-reassign: 0 */
  var values = items instanceof Array ? items : Object.keys(items);
  values.forEach(function (item) {
    collection[item] = true;
  });
}

function actuallyDownload() {
  /* eslint no-console: 0 */
  var action = next;
  prepareNext();
  downloadCourses(Object.keys(action.courses)).then(addWords).then(function () {
    return downloadWords(Object.keys(action.words));
  }).then(addWords).then(notify)["catch"](function (error) {
    console.error(error);
    notifyError(error);
  });
}

function addWords(words) {
  if (!words) {
    return;
  }

  if (typeof words === 'string') {
    addWords(JSON.parse(words));
    return;
  }

  Object.keys(words).forEach(function (key) {
    (0, _dictionary.setWord)(key, words[key].map(_formatEntry2["default"]));
  });
}

function downloadCourses(newCourses) {
  var courses = newCourses.filter(function (course) {
    return !(course in coursesLoaded);
  });
  return new _rsvp.Promise(function (resolve, reject) {
    if (courses.length) {
      _xhr2["default"].get({
        url: api + '?goal_ids=' + encodeURIComponent(courses.join(',')),
        headers: headers
      }, function (error, response, body) {
        if (error) {
          reject(error);
        } else if (isBadResponse(response)) {
          reject(response);
        } else {
          // So they're not scheduled next time
          pour(coursesLoaded, newCourses);
          resolve(body);
        }
      });
    } else {
      resolve({});
    }
  });
}

function downloadWords(newWords) {
  var words = newWords.filter(function (word) {
    return !(0, _dictionary.hasWord)(word);
  });
  return new _rsvp.Promise(function (resolve, reject) {
    if (words.length) {
      _xhr2["default"].post({
        url: api,
        headers: headers,
        json: {
          text: words.join(' ')
        }
      }, function (error, response, body) {
        if (error) {
          reject(error);
        } else if (isBadResponse(response)) {
          reject(response);
        } else {
          resolve(body);
        }
      });
    } else {
      resolve({});
    }
  });
}

function isBadResponse(response) {
  return !response || response.statusCode > 399;
}